var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumbingStoppage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.03 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "plumbing"
  }, "Plumbing Stoppage Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "plumbing"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.68,16.3h9.5a.75.75,0,0,0,0-1.5H33.65c-11,.32-13,9.72-13.33,12.12a2.68,2.68,0,0,0-.06,5v.82c0,2.77-.48,5.94-4.18,5.94a4.76,4.76,0,0,1-3.71-1.37,6,6,0,0,1-1.17-4.21V21.06A2.7,2.7,0,0,0,13,18.53,2.67,2.67,0,0,0,11.2,16V.77a.75.75,0,1,0-1.5,0V8.38a8,8,0,0,1-2.79-.54,9.46,9.46,0,0,0-3.45-.71V.77A.75.75,0,0,0,2,.77V16a2.68,2.68,0,0,0,0,5V33.11c0,.27-.29,6.57,3.74,10.93C8,46.54,11.26,47.87,15.36,48h.53a12.71,12.71,0,0,0,9.34-3.44c4-4,3.92-10.1,3.92-10.34V32.08a2.7,2.7,0,0,0,2.11-2.64,2.66,2.66,0,0,0-2-2.56c.39-1.21,1.77-3.54,6.48-3.54h7a.75.75,0,0,0,0-1.5h-7c-6,0-7.59,3.42-8,4.93H21.85C22.25,24.23,24.22,16.58,33.68,16.3ZM6.24,9.18a9.12,9.12,0,0,0,3.46.7v6H3.46V8.63A7.87,7.87,0,0,1,6.24,9.18ZM2.87,17.36h7.41a1.19,1.19,0,0,1,0,2.37H2.87a1.18,1.18,0,0,1-1.17-1.2A1.17,1.17,0,0,1,2.87,17.36Zm21.3,26.11c-2.09,2.09-5.05,3.12-8.77,3S8.84,45.22,6.81,43c-3.6-3.88-3.36-9.79-3.35-9.88V21.23H9.7V33.06a7.46,7.46,0,0,0,1.55,5.29,6.17,6.17,0,0,0,4.83,1.88c3.77,0,5.68-2.5,5.68-7.44v-.65h5.89v2.08C27.65,34.28,27.75,39.89,24.17,43.47Zm5.59-14a1.18,1.18,0,0,1-1.18,1.18H21.17A1.18,1.18,0,0,1,20,29.44a1.17,1.17,0,0,1,1.17-1.17h7.41A1.18,1.18,0,0,1,29.76,29.46Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.96,
    cy: 38.57,
    r: 0.74
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.32,
    cy: 37.09,
    r: 0.74
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.92,
    cy: 40.49,
    r: 0.74
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.79,
    cy: 41.74,
    r: 0.74
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.65,
    cy: 43.29,
    r: 1.11
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.27,
    cy: 43.78,
    r: 1.09
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.46,
    cy: 40.45,
    r: 1.44
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.16,
    cy: 43.66,
    r: 2.51
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.77,
    cy: 41,
    r: 2.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingStoppage);
export default __webpack_public_path__ + "static/media/plumbing-stoppage.3d4c2a2f16d4a7cbad5ba03dc4645374.svg";
export { ForwardRef as ReactComponent };